import React, { useState } from "react";
import { SmsRequest } from "../../Services/API";
import { SendFlightBookingNotifications } from "../../Services/API";

const SmsTicket = ({ referenceNo, trackId }) => {
  const [smsNumber, setSmsNumber] = useState("");
  const [smsPricing, setSmsPricing] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClickSMS = async () => {
    // Basic validation
    if (!smsNumber) {
      alert("Please enter mobile number");
      return;
    }

    // Simple Indian mobile validation (10 digits)
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobileRegex.test(smsNumber)) {
      alert("Please enter valid 10-digit mobile number");
      return;
    }

    // if (!smsPricing) {
    //   alert("Please select a pricing option");
    //   return;
    // }

    try {
      setLoading(true);

       const payload = {
          referenceNo: referenceNo,
          trackId: trackId,
          communicationType: "SMS",
          communicationOn: smsNumber,
          pricingOption: smsPricing,
          clientCode: "BerryJourneys"
        };
  
        console.log("SendFlightBookingNotifications", payload);
        const response = await SendFlightBookingNotifications(payload);

        if (response?.Status === "OK") {
        alert("SMS sent successfully!");
        setSmsNumber("");
        setSmsPricing("");
        //window.location.reload();
      } else {
        alert("Failed to send SMS.");
      }
    } catch (error) {
      console.error("SMS Error:", error);
      alert("Something went wrong while sending SMS.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="form_row">
          <label className="required">Mobile Number</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Mobile Number..."
            value={smsNumber}
            onChange={(e) => setSmsNumber(e.target.value)}
            maxLength={10}
          />
        </div>
      </div>

      <div className="col-md-12 text-end mt-3">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={handleClickSMS}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send SMS"}
        </button>
      </div>
    </div>
  );
};

export default SmsTicket;
